import html from '../../src/icons/html.png';
import react from '../../src/icons/react.png';
import css3 from '../../src/icons/css3.png';
import vuejs from '../../src/icons/vue.png';
import javascript from '../../src/icons/javascript.png';
// adobe imports
import photoshop from '../../src/icons/photoshop.svg';
import animate from '../../src/icons/animate.svg';
import aftereffects from '../../src/icons/aftereffects.svg';
import illustrator from '../../src/icons/illustrator.svg';
import mediaencoder from '../../src/icons/mediaencoder.svg';
import figma from '../../src/icons/figma.png';
import hype from '../../src/icons/hype.png';
import blender from '../../src/icons/blender.png';

const Home = () => {
  return (
    <div className="homepageBlock">
      <div className="topBlock">
        {/* <div className="profile-icon">
          <img className="profile-icon-img" src={logoImage} />
        </div> */}
        <div className="textTitle">
          <h1 className="textHeader">Привет, меня зовут Илья</h1>
          <h3 className="textSubheader">Я - Frontend-разработчик</h3>
          <h3 className="textSubheader">Digital & Motion-дизайнер</h3>
          <p className="textSubheader3">TG: @xkupriyanov</p>
        </div>
      </div>
      <div className="bottomBlock">
        <h1 className="textSubheader2">Стек разработки</h1>
        <div className="stack">
          <div className="stack-item">
            <h3>Hard Skills</h3>
            <img className="item-image" src={html} />
            <img className="item-image" src={css3} />
            <img className="item-image" src={javascript} />
            <img className="item-image" src={vuejs} />
            <img className="item-image" src={react} />
          </div>
        </div>
        <div className="stack">
          <div className="stack-item">
            <h3>Программы</h3>
            <img className="item-image" src={figma} />
            <img className="item-image" src={photoshop} />
            <img className="item-image" src={animate} />
            <img className="item-image" src={aftereffects} />
            <img className="item-image" src={illustrator} />
            <img className="item-image" src={mediaencoder} />
            <img className="item-image" src={hype} />
            <img className="item-image" src={blender} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;